<template>
  <article class="collection" v-if="collection" :class="collection.slug">
    <header>
      <h1 class="h2 type-scales--large">
        <template v-if="number">
          Collection
          <br>
        </template>
        <template v-if="number">
          Nr. {{number}}
          <br>
        </template>
        <template v-if="isBespoke">
          Dovedale Design<br/>Studio’s<br/>
        </template>
        {{title}}
        <template v-if="isBespoke">
          <div class="logo">
            <LogoMarque/>
          </div>
        </template>
        <!-- <template v-if="!number">
          <br>
          Dovedale Design Studio
        </template> -->
      </h1>
    </header>

    <story v-if="loadStory" :sections="collection.getGroup('collection.sections').value" :mobile="mobile" :window="window"></story>
    
    <items :collections="collections" :slug="slug" :itemViewName="'Collection - Item Overlay'"></items>
    
    <!-- <div v-if="slug === 'bespoke-service' && collections.length && collections[0].data['collection.items--enquire-email']">
      <a :href="'mailto:' + collections[0].data['collection.items--enquire-email'].value[0].text" class="enquire-btn">Enquire</a>
      <br/>
    </div> -->

    <nav class="outlined is-hidden-mobile">
      <router-link class="previous" v-if="prevCollection" :to="{name: 'Collection', params: {slug: prevCollection.uid}}"><span>Previous</span></router-link>
      <div class="underline-links">
        <span class="h7 nimbus-sans">Share via <template v-for="button in shareBtns"><a :href="button.url" target="_blank">{{button.label}}</a>&nbsp;</template></span>
      </div>
      <router-link class="next" v-if="nextCollection" :to="{name: 'Collection', params: {slug: nextCollection.uid}}"><span>Next</span></router-link>
    </nav>
    <nav class="is-hidden-tablet uppercase">
      <router-link :to="{name: 'Collections'}">Back to Collections</router-link>
    </nav>
    
    <!-- <footerr v-if="site" :site="site"></footerr>-->
    <footer v-if="site" class="is-hidden-mobile">
      <div>
        <subscribe-form :mailchimpNewsletterID="site.getText('site.mailchimp-newsletter-id')"></subscribe-form>
      </div>
    </footer>
    <appfooter :site="site"></appfooter>
  </article>
</template>

<script>
import Vue from 'vue'
// import Config from 'src/config'
import Story from './Collection__Story'
import Items from './Collection__SKUs'
import SubscribeForm from 'src/components/SubscribeForm'
import Appfooter from 'src/components/Footer'
import LogoMarque from 'src/components/LogoMarque'
// import Footerr from './Footer'
export default {
  name: 'collection',
  props: ['window', 'mobile', 'slug', 'site', 'collections'],
  data () {
    return {
      loadStory: false
    }
  },
  metaInfo () {
    const title = this.collection ? this.collection.getText('collection.title') : 'Dovedale Design Studio'
    const description = this.collection ? this.collection.getText('collection.meta_description') : ''
    const metaKeywords = this.collection ? this.collection.getText('collection.meta_keywords') : ''
    const shareImage = this.collection && this.collection.data['collection.share_image'] && this.collection.data['collection.share_image'].value.main.url ? this.collection.data['collection.share_image'].value.main.url : ''

    // console.log('title', title)
    // console.log('description', description)
    // console.log('metaKeywords', metaKeywords)
    // console.log('shareImage', shareImage)
    // console.log(this.collection)

    return {
      meta: [
        {name: 'description', content: description},
        {name: 'keywords', content: metaKeywords},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        // {property: 'og:type', content: 'website'},
        {property: 'og:image', content: shareImage},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description},
        {name: 'twitter:image:src', content: shareImage},
        {itemprop: 'name', content: title},
        {itemprop: 'description', content: description},
        {itemprop: 'image', content: shareImage}
      ]
    }
  },
  components: {
    Story,
    Items,
    SubscribeForm,
    Appfooter,
    LogoMarque
  },
  computed: {
    isBespoke () {
      if (this.collection.slug === 'bespoke-service') {
        return true
      }
    },
    collectionIndex () {
      if (this.collections) {
        const matches = this.collections.map((collection, index) => {
          if (collection.uid === this.slug) {
            return index
          }
        }).filter(isFinite)
        return matches[0]
      }
      return null
    },
    collection () {
      return this.collections ? this.collections[this.collectionIndex] : null
    },
    number () {
      return this.collection.getNumber('collection.number')
    },
    title () {
      return this.collection.getText('collection.title')
    },
    featuredImg () {
      const img = this.collection.getImage('collection.index-image--mobile').url
      return img || false
    },
    prevCollection () {
      return this.getSibling(-1)
    },
    nextCollection () {
      return this.getSibling()
    },
    shareBtns () {
      let channels = [
        {
          label: 'Twitter',
          url: 'https://twitter.com/intent/tweet?url=' + document.location.href
        },
        {
          label: 'Email',
          url: 'mailto:?&subject=' + encodeURIComponent(document.title) + '&body=' + document.location.href
        },
        {
          label: 'Facebook',
          url: 'https://www.facebook.com/sharer.php?u=' + document.location.href
        }
      ]
      // add pinterest ?
      if (this.featuredImg) {
        channels.push({
          label: 'Pinterest',
          url: 'https://pinterest.com/pin/create/bookmarklet/?media=' + this.featuredImg + '&url=' + document.location.href + '&description=' + document.location.title
        })
      }
      return channels
    }
  },
  watch: {
    collection () {
      this.updateMeta()
    },
    '$route' (to, from) {
      if (to.name === 'Collection') this.updateMeta()
      this.setLoadStory()
    }
  },
  methods: {
    updateMeta () {
      if (!this.collection) return false
      const title = this.collection.getText('collection.title')
      Vue.updateMeta.setTitle(title)
      const descrip = this.collection.getText('collection.meta_description')
      if (descrip) Vue.updateMeta.setDescription(descrip)

      // const title2 = this.collection.getText('collection.title') ? this.collection.getText('collection.title') : 'Dovedale Design Studio'
      // const description = this.collection.getText('collection.meta_description') ? this.collection.getText('collection.meta_description') : ''
      // const metaKeywords = this.collection.getText('collection.meta_keywords') ? this.collection.getText('collection.meta_keywords') : ''
      // const shareImage = this.collection.data['collection.share_image'].value.main.url ? this.collection.data['collection.share_image'].value.main.url : ''

      // console.log('title', title2)
      // console.log('description', description)
      // console.log('metaKeywords', metaKeywords)
      // console.log('shareImage', shareImage)
      // console.log(this.collection)
    },
    getSibling (direction = 1) {
      const bro = this.collections[this.collectionIndex + direction]
      if (bro) {
        if (bro.data['collection.hide-on-index']) {
          return bro.getBoolean('collection.hide-on-index') ? null : bro
        }
        return bro
      }
      return null
    },
    setLoadStory () {
      this.loadStory = this.$route.name === 'Collection'
    }
  },
  created () {
    this.updateMeta()
    this.setLoadStory()
  }
}
</script>

<style lang="scss">
.bespoke-service {
  .logo {
    margin-top: 2vh;
    height: 7vh;
    width: 100%;
    display: flex;
    justify-content: center;
    svg {
      * {
        stroke: white;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '../style/variables';

.collection{
  background:$white;
  min-height:100vh;

  > header{
    @include vcenter_content($child:h1);    
    width:100%;
    height:100vh;
    min-height:320px;
    padding:0 $gutter;

    > h1{
      width:100%;
      line-height:14vh;
      text-transform: uppercase;
    }
  }
  
  &.bespoke-service {
    > header{
      background-image:url('https://images.prismic.io/dovedale-deisgn-studio/c3718869-d80e-4d48-86e0-90acb98a28bb_B%26W+Janji+Table+Banner.jpg?auto=compress,format&w=2000');
      background-size:cover;
      background-position:center;
      height: 50vh;
      background-color: #bbb;
      // if desktop
      @media (min-width: 769px) {
        margin-top: 10vh;
      }
      color: white;
    }
    header > h1 {
      line-height: 8vh;
    }
  }

  .collection--items{
    margin-top: 88.5em/$basefont;
    border-top-style:solid;
  }

  > nav.is-hidden-mobile{
    border-style:solid none solid none;
    position: relative;
    > *{
      padding:2.15em 0;
    }
    > a {
      width:17.919921875%;
      position:absolute;
      top:0; 
      &.previous{
        left:0;
        border-right-style:solid;
        &:before{
          left:$gutter;
        }
      }
      &.next{
        right:0;
        border-left-style:solid;
        &:before{
          right:$gutter;
          transform:rotate(180deg);
        }
      }
      // icon
      &:before{
        content:'';
        display:none;
        background-image:url(../assets/arrow.svg);
        background-size:contain;
        background-repeat:no-repeat;
        background-position:center center;
        width:2.375em;
        height:0.5625em;
        position:absolute;
        top:calc(50% - 0.5625em / 2);
        @media (min-width:1150px) {
          display:block;
        }
      }
      // label
      span {
        @include h8();
        text-transform: uppercase;  
      }
    }
  }

  > footer{
    margin:6.25em 0;
    padding:0 $collectionMobile-textMargin-ew;
    > div{
      max-width:29.8125em;
      margin:0 auto;  
    }
  }
}

@include on_mobile() {
.collection{

  > header{
    display:block;
    min-height:0;
    height:auto;
    padding-top: $collectionMobile-blockMargin-ns*2;
    margin-bottom: $collectionMobile-blockMargin-ns;
    h1{
      @include h5();
      line-height: 2.5;
    }
  }
  
  // .bespoke-service > header {
  //   margin-top: 0;
  // }

  > nav.is-hidden-tablet{
    border-top: 1px solid;
    padding:1.5em $collectionMobile-textMargin-ew;
  }

  #footer{
    border-top-style:solid;
  }
} 
}

</style>



// WEBPACK FOOTER //
// Collection.vue?1dac3680